
import { Backdrop, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

export function ServiceWorkerUpdateDialog({ dialog }) {

    if (!dialog) return null;

    return (
        <>
            <Backdrop
                sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 9998,
                }}
                open={dialog}
            />
            <Box
                sx={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 'auto' },
                    minWidth: { sm: '320px' },
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                    zIndex: 9999,
                    textAlign: 'center',
                }}
            >
                <Typography variant="h3" component="h2" gutterBottom>
                    New Update Available
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Please wait until the new version is installed in the background.
                </Typography>
            </Box>
        </>
    );
}

ServiceWorkerUpdateDialog.propTypes = {
    dialog: PropTypes.bool,
};